import React, {createContext, useReducer} from 'react'

export const SET_INLINE_CONNECTION_LIST = 'SET_INLINE_CONNECTION_LIST'
export const SELECT_INLINE_CONNECTION = 'SELECT_INLINE_CONNECTION'
export const SET_SHOW_INLINE_POPUP = 'SET_SHOW_INLINE_POPUP'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_INLINE_CONNECTION_LIST:
      return { ...data, inline_connection_list: payload.data }
    case SELECT_INLINE_CONNECTION:
      return {
        ...data,
        selected_inline_connection: payload.data.selected_inline_connection,
        show_inline_popup: payload.data.show_inline_popup,
      }
    case SET_SHOW_INLINE_POPUP:
      return {
        ...data,
        show_inline_popup: payload.data,
        selected_inline_connection: payload.data ? data.selected_inline_connection : {},
      }
    default:
      return data
  }
}

const initialState = {
  inline_connection_list: [],
  selected_inline_connection: {},
  show_inline_popup: false,
}

const InlineConnectionStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <InlineConnectionContext.Provider value={[state, dispatch]}>
      {children}
    </InlineConnectionContext.Provider>
  )
}

export const InlineConnectionContext = createContext(initialState)
export default InlineConnectionStore
